import type { AgentSession, Investigation } from '@litlingo/client';
import LinkLookup from 'components/LinkLookup';
import daysAgo from 'components/utils/daysAgo';
import React from 'react';

type ComponentProps = {
  investigation: Investigation;
  session: AgentSession;
};

const SessionListRow: React.FC<ComponentProps> = ({ investigation, session }) => (
  <tr
    className="table-row border-t border-gray-200 align-middle hover:bg-litlingo-gray-0 cursor-pointer"
    data-testid={`session-row-${session.uuid}`}
  >
    <td className="table-wrapper__new-td">
      <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
        <span className="text-body line-clamp-2">{session.agent_objective}</span>
      </div>
    </td>
    <td className="table-wrapper__new-td">
      <div className="table-wrapper__new-cell-content h-auto m-0 p-0 pr-2 flex text-body">
        <span className="truncate text-body">{session?.status?.toUpperCase() ?? '—'}</span>
      </div>
    </td>
    <td className="table-wrapper__new-td">
      <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
        <span className="text-body">{session.input_tokens ?? '—'}</span>
      </div>
    </td>
    <td className="table-wrapper__new-td">
      <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
        <span className="text-body">{session.output_tokens ?? '—'}</span>
      </div>
    </td>
    <td className="table-wrapper__new-td">
      <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
        <span className="text-body">{session.step_count ?? '—'}</span>
      </div>
    </td>
    <td className="table-wrapper__new-td">
      <div className="table-wrapper__new-cell-content h-auto m-0 p-0 flex text-body">
        <span className="text-body">{session.updated_at ? daysAgo(session.updated_at) : '—'}</span>
      </div>
    </td>
    <td className="table-wrapper__tbody-td h-8">
      <LinkLookup
        className="button button--secondary h-6 whitespace-no-wrap"
        data-testid={`open-session-${session.uuid}`}
        routeName="agent-chat"
        routeParams={{ investigationId: investigation.uuid, agentId: session.uuid }}
      >
        Open session
      </LinkLookup>
    </td>
  </tr>
);

export default SessionListRow;
